<template>
  <el-container id="site-screen">
    <el-main class="background-img">
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "DeviceDoc"
}
</script>

<style scoped>
  #site-screen {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
  }
  .background-img {
    background-image: url("../../../assets/images/即将上线.png");
    background-size: 700px;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DeviceDoc/DeviceDoc.vue